import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import 'jstree';

export default class ReactTree extends React.Component {

  constructor(props){
    super(props);

    //this.setState({copyInstance:null})
    this.copyInstance = null
    this.instance = null
  }

  componentDidMount() {
      let that = this
      //ReactDOM.findDOMNode(this)
    this.instance = $('#jstree')
      .on('changed.jstree', (e, data) => {
        if (this.props.onChanged) {
          this.props.onChanged(data.selected.map(
            item => data.instance.get_node(item)
          ));
        }
      })
      .on('create_node.jstree',(e,data)=>{
          if(this.props.onCreateNode){
            this.props.onCreateNode(data)
          }
      })
      .on('delete_node.jstree',(e,data)=>{
        if(this.props.onDeleteNode){
          this.props.onDeleteNode(data)
        }
      })    
      .on('rename_node.jstree',(e,data)=>{
          if(this.props.onRenameNode){
            this.props.onRenameNode(data)
          }
      })
      .on('move_node.jstree',(e,data)=>{
        this.copyInstance = null
        if(this.props.onMoveNode){
          this.props.onMoveNode(data)
        }
      })
      .on('open_node.jstree',(e,data)=>{        
        if(this.props.onOpenNode){
          this.props.onOpenNode(data)
        }
      })
      .on('close_node.jstree',(e,data)=>{        
        if(this.props.onCloseNode){
          this.props.onCloseNode(data)
        }
      })
      .on('copy_node.jstree',(e,data)=>{        
        if(this.props.onCopyNode){
          this.props.onCopyNode(data)
        }
      })
      .on('copy.jstree',(e,data)=>{
        this.copyInstance = data
        if(this.props.onCopy){
          this.props.onCopy(data)
        }
      })
      .on('paste.jstree',(e,data)=>{
        console.log('paste.jstree')
        this.copyInstance = null
        if(this.props.onPaste){
          this.props.onPaste(data)
        }
      })
      .on('select_node.jstree',(e,data)=>{
        if(this.props.onSelect){
            this.props.onSelect(data.node,data.selected,data.event)
          }
      })
      .on('newwork_node.jstree',(e,data)=>{
        console.log('new work callback')
    })  
      .jstree({
        core: this.props.core,        
        "plugins" : [ "contextmenu","dnd" ,"sort"],
        'sort' : function(a, b) {
          let a1 = this.get_node(a);
          let b1 = this.get_node(b);
                    
          let a1l=  a1.text.split('.');
          let b1l=  b1.text.split('.');
          if(a1.id=='trash'){
            return 1
          }else if(a1l.length>1 && b1l.length>1){
            if(!isNaN(a1l[0]) && !isNaN(b1l[0])){
              return (a1l[0]*1 > b1l[0]*1) ? 1 : -1;                
            }else if(!isNaN(a1l[0])){
              return -1;
            }else if(!isNaN(b1l[0])){
              return 1;
            }else{
              return (a1.text > b1.text) ? 1 : -1;	
            }
          }else if(a1l.length>1 || b1l.length>1){
              if(!isNaN(a1l[0])){
                return -1;
              }else if(!isNaN(b1l[0])){
                return 1;
              }else
                return (a1.text > b1.text) ? 1 : -1;	
          }else{
              return (a1.text > b1.text) ? 1 : -1;
          }
          
        },
        contextmenu:{
            items:function(n) {
                let tmp = $.jstree.defaults.contextmenu.items();
              //console.log('props',that.props)
                if(n.parent=='trash'){
                  delete tmp["create"];                  
                  delete tmp["rename"];
                  delete tmp["ccp"];
                  delete tmp["remove"];
                  // tmp.remove.label = 'ลบไฟล์ตลอดกาล';
                  // tmp.remove.icon  = 'fa fa-trash';
                  // tmp.remove['forever'] = true
                  tmp['forever']  = {label:'ลบไฟล์ตลอดกาล',icon:'fa fa-trash',action:function(obj){
                    if(that.props.onDeleteForever!==undefined){
                      let instance = $('#jstree').jstree()  
                      that.props.onDeleteForever(obj,n,instance)
                    }
                  }}
                  
                  return tmp
                }
                if(n.original.is_file || n.original.children==undefined){
                  delete tmp["create"];
                  tmp.remove.label = 'ลบไฟล์';
                  tmp.remove.icon  = 'fa fa-trash';
                  
                }else{
                  tmp.create.label = 'สร้างโฟลเดอร์';
                  tmp.create.icon  = 'fa fa-folder-o';
                  tmp.remove.label = 'ลบโฟลเดอร์';
                  tmp.remove.icon  = 'fa fa-trash';
                    
                  let template  = {'template':{"separator_after": true,label:'สร้างไฟล์จากเทมเพลต',icon:'fa fa-file-o',
                    submenu:that.props.template.map((item,index)=>{
                      item['action'] = function(obj){
                        if(that.props.onTemplateSelect!==undefined){
                          //let instance = that.instance
                          let instance = $('#jstree').jstree()                          
                          that.props.onTemplateSelect(obj,n,instance)
                        }
                      }
                      return item
                    })
                  }}

                  tmp = Object.assign(template,tmp)
                  
                }

                tmp.rename.label = 'เปลี่ยนชื่อ';
                tmp.rename.icon  = 'fa fa-edit';
                tmp.ccp.label = 'แก้ไข';
                tmp.ccp.icon = 'fa fa-edit';
                tmp.ccp.submenu.copy.label ='คัดลอก';
                tmp.ccp.submenu.copy.icon  = 'fa fa-copy';
                tmp.ccp.submenu.cut.label ='ย้าย';
                tmp.ccp.submenu.cut.icon  = 'fa fa-cut';
              //console.log("copy",that,that.state)
                if(that.copyInstance!==null && !n.original.is_file){
                  tmp.ccp.submenu.paste.label ='วาง';
                  tmp.ccp.submenu.paste.icon  = 'fa fa-paste';
                }else{
                  delete tmp.ccp.submenu["paste"]
                }
                // tmp.newwork = {
                //     separator_before:true,
                //     label :'สร้างใบงานซ่อม',
                //     icon :'fa fa-file',
                //     action : (e,data)=>{
                //         console.log('newWork');
                //         if(that.props.onNewWork!==undefined){
                //             that.props.onNewWork(e,n)
                //         }
                //     }
                // };
                //View work
                console.log('jsTree',tmp,n)
                return tmp;
            }
          },
      });

      
  }

  getInstance(){
    return this.instance
  }

  render() {
    return (<div id='jstree'></div>);
  }
}

ReactTree.propTypes = {
  core: function (props, propName, componentName) {
    const core = props[propName];
    if (!core || typeof (core) !== 'object')
      return new TypeError(`Invalid prop \`core\`: must follow jsTree API, read more https://www.jstree.com/api/#/?q=core`);

    const data = core.data;
    if (!Array.isArray(data) && typeof (data) !== 'object')
      throw new TypeError(`Invalid object \`core.data\`: must be array of object of jsTree JSON data, read more https://www.jstree.com/docs/json`);
  }
};



// WEBPACK FOOTER //
// ./src/view/qo/ReactTree.js